// extracted by mini-css-extract-plugin
module.exports = {"container":"gi","addToButton":"hi","basic":"ii","disabled":"ji","m-heart-activate":"ki","lists":"li","addNew":"mi","m-heart-pulse":"ni"};